import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';
import { IUpsertCollectionRequestBody } from '@types';

// 컬렉션 생성/수정 API 요청 함수
// isCreate true일 시 POST, false일 시 PATCH
// POST data interface - {id:number} / PATCH data interface - undefined

type UpsertCollectionResponse = AxiosResponse<FetchResult<{ id: number } | undefined>>;
type UpsertCollectionError = AxiosError<{ errorMessage: string }>;
type UpsertCollectionVariables = {
  isCreate: boolean;
  body: IUpsertCollectionRequestBody;
  collectionId?: number;
};

async function upsertCollection<T extends boolean>(variables: {
  isCreate: T;
  body: IUpsertCollectionRequestBody;
  collectionId?: number;
}): Promise<AxiosResponse<FetchResult<T extends true ? { id: number } : undefined>>> {
  const response = variables.isCreate
    ? await instance.post(`/collections`, variables.body)
    : await instance.patch(`/collections/${variables.collectionId}`, variables.body);
  return response;
}

const useUpsertCollection = () => {
  const { mutate, isPending } = useMutation<UpsertCollectionResponse, UpsertCollectionError, UpsertCollectionVariables>(
    {
      mutationKey: ['upsert', `/collections`],
      mutationFn: upsertCollection,
      retry: false
    }
  );

  return { mutate, isPending };
};

export default useUpsertCollection;
